import { Type } from '@angular/core';
import { LeaveFeedbackBaseStep } from '@luggagehero/features/bookings';

import { LeaveFeedbackActionComponent } from '../booking-actions';

export class LeaveFeedbackStep extends LeaveFeedbackBaseStep {
  get leaveFeedbackActionComponentType(): Type<LeaveFeedbackActionComponent> {
    return LeaveFeedbackActionComponent;
  }
}
